import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material'

interface Props {
  title: string
}

/**
 * ページヘッダ
 */
export const PageHeader: React.FC<Props> = (props) => {
  const { title } = props
  const theme = useTheme()
  // 画面サイズが'md(900px)'以上の場合true
  const isMobileSize = !useMediaQuery(theme.breakpoints.up('md')) // smでは見出しとロゴが被ってしまうケースがあるのでここは敢えてmd
  const logoWidth = isMobileSize ? '107px' : '191px'
  const logoMargin = isMobileSize ? '1em' : '2.28em'
  const titlePT = isMobileSize ? '4.5em' : '4.5em'
  const titlePB = isMobileSize ? '1em' : '4em'

  // svgファイルのrefを宣言
  const headerLogo = React.useRef<HTMLObjectElement>(null)
  // aタグのrefを宣言
  const logoLink = React.useRef<HTMLAnchorElement>(null);

  return (
    <>
      <Box
        sx={{
          pt: titlePT,
          pb: titlePB,
        }}
      >
        <Typography component='h1'
          sx={{
            color: '#000',
            fontSize: '1.5em',
            letterSpacing: 0,
            textAlign: 'center',
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'fixed',
          // top: '2.34em',
          // right: '2.28em',
          top: logoMargin,
          right: logoMargin,
          zIndex: 100,
        }}
      >
        <a
          onMouseOver={(e) => {
            // マウスオーバー時に色を青く変更
            const svgLogoList = headerLogo.current?.contentDocument?.querySelectorAll("path")
            svgLogoList?.forEach((svgLogo: any) => {
              svgLogo.style.fill = "#004499"
            })
          }}
          onMouseOut={(e) => {
            // マウスアウト時に色を元に戻す
            const svgLogoList = headerLogo.current?.contentDocument?.querySelectorAll("path")
            svgLogoList?.forEach((svgLogo: any) => {
              svgLogo.style.fill = "#222"
            })
          }}
          ref={logoLink}
          href="https://www.plus-cs.co.jp/"
          id="topPageLink"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
          }}
        />
          <object
            ref={headerLogo}
            type="image/svg+xml"
            data={`${process.env.PUBLIC_URL}/logo.svg`}
            id="headerLogo"
            className="logo"
            style={{
              width: logoWidth,
            }}
          />
      </Box>
    </>
)
}

export default PageHeader
